import reduxFetch from 'react-redux-fetch';
import { createErrorMessage } from 'nallian-shared-ui/lib/lib/createErrorMessage';
import apiRoutes from '../../../app/api/routes';
import { IMPERSONATION_REQUEST_RESOURCE } from '../constants';

const createImpersonationRequestService = ComposedComponent =>
  reduxFetch([
    {
      resource: IMPERSONATION_REQUEST_RESOURCE,
      method: 'post',
      request: (body, callback, t) => ({
        url: apiRoutes.impersonationRequests(),
        body,
        meta: {
          callback,
          toaster: {
            onErrorMessage: createErrorMessage(t, 'impersonationRequestFailed'),
            onSuccessMessage: t('impersonationRequestCreated'),
          },
        },
      }),
    },
  ])(ComposedComponent);

export default createImpersonationRequestService;
